// extracted by mini-css-extract-plugin
export var container = "_de-0";